import React, { useState, useEffect } from "react";
import { Button, Dialog, IconButton, TextField, Typography, Tabs, Tab, Select, MenuItem, Checkbox, ListItemText, InputLabel, FormControl, CircularProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import DeleteIcon from '@mui/icons-material/Delete';


const isMobile = window.innerWidth < 900;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  width: ${isMobile ? "100%" : "98%"};
  border-radius: 8px;
  margin-left: ${isMobile ? "0px" : "10px"};
  margin-bottom: ${isMobile ? "0px" : "10px"};
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`;

const ButtonContainer = styled.div`
  display: flex !important;
  justify-content: center !important;
  align-items: center;
  margin-top: 10px;
`;

const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const SpecimenAllotmentModal = ({ props, onClose1, remarks, data, id, distributorId, fetchData, selectedTab, }) => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [clusters, setClusters] = useState([])
  const [form, setForm] = useState({
    name: props?.nameSku || '',
    id: props?.id || '',
    quantity: props?.quantity || '',
    class: props?.classId || '',
    seriesCategoryId: props?.seriesTableId || '',

  });
  const [errors, setErrors] = useState({});
  const [getSeriesCategory, setgetSeriesCategory] = useState()
  const [getSubjects, setGetSubject] = useState()
  const [className, setClassName] = useState()
  const [selectedClass, setSelectedClass] = useState("")
  const [board, setBoard] = useState()
  const [medium, setMedium] = useState()
  const [selectDataFilter, setSelectDataFilter] = useState({
    board: '', class: '', medium: '', sku: '', price: ''
  })
  const [filterClass, setFilterClass] = useState()
  const [filterProducts, setFilterProducts] = useState()
  const [dataGrid, setDataGrid] = useState([])
  const [assignTo, setAssignTo] = useState("");
  const [specimenProduct, setSpecimenProduct] = useState([])

  useEffect(() => {
    // getMedium();
    // getBoard();
    getClass();
    // getSubject();
    getSeriesCategoryData();
    // getClusterInPicklist();
    getSpecimenProduct();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  const getBoard = async () => {
    let results = await window.Platform.database.getBoard();
    setBoard(results.data)
    if (props?.boardId) {
      const item = results.data.filter((result) => result.boardId === props.boardId)
      // setSelectedBoard(item);
    }
  }

  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();

      if (results && results.status) {
        setClusters(results.data)
      }
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  }


  const getSpecimenProduct = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getSpecimenProduct();

      if (results && results.status) {
        setSpecimenProduct(results.data)
        setFilterProducts(results.data)
      }
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  }


  const getClass = async (data) => {
    const results = await window.Platform.database.getClass(data);
    const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

    setClassName(jsonArrayWithId)

    if (props?.classId) {
      const item = jsonArrayWithId.filter((result) => result.classId === props.classId)
      setSelectedClass(item);
    }
  }


  const getMedium = async () => {
    let results = await window.Platform.database.getMedium();
    setMedium(results.data)
    if (props?.mediumTableId) {
      const item = results.data.filter((result) => result.mediumTableId === props.mediumTableId)
      // setSelectedMedium(item);
    }
  }

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }


  const handleDeleteEmploye = async (id) => {
    // const response = await window.Platform.database.deleteUsers(ID);

    let res = dataGrid.filter((el) => {
      return el.id != id;
    });

    setDataGrid(res);
  };


  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }

  const changeHandler = (fieldName, value) => {

    let val = value;
    setForm((prevForm) => ({ ...prevForm, [fieldName]: val }));
  };
  console.log(form, "====>>>>form")

  const productHandler = (data) => {
    changeHandler("name", data);
  }

  const mediumHandler = (data) => {
    changeHandler("medium", data);
    // changeHandler("mediumName",data.mediumName)
    const mediumData = medium.find((item) => item.mediumTableId === data);
    changeHandler("mediumName", mediumData.mediumName)
    // setSelectedMedium(data)

  }
  const classHandler = (data) => {
    changeHandler("class", data);
    // changeHandler("className",data.className)
    const classData = className.find((item) => item.classId === data);
    changeHandler("className", classData.className)
    setSelectedClass(data)
    filterProductsfunc(form.seriesCategoryId, data)

  }

  function filterProductsfunc(ser, cls) {
    console.log(cls, ser, specimenProduct)

    let a = specimenProduct.filter((ele) => {
      return (!ser || ele.seriesCategory == ser) && (!cls || ele.classId == cls)
    })
    setFilterProducts(a);
  }

  const subjectName = (data) => {
    changeHandler("subject", data)
    const subjectData = getSubjects.find((item) => item.subjectId === data);
    changeHandler("subjectName", subjectData.subjectName)
    // setSubject(data)

  }

  const getSubject = async () => {
    let results = await window.Platform.database.getSubject();
    setGetSubject(results.data)
    if (props?.subjectId) {
      const item = results.data.filter((result) => result.subjectId === props.subjectId)
      // setSubject(item);
    }

  }

  const handleAdd = (data) => {
    if (userData && userData?.role == "asm") {
      if (!rm) {
        return window.alert("Please Select RM");
      }
    }
    else {
      if (!assignTo || assignTo == "") {
        return window.alert("Please Assign a role");
      }
      else if (assignTo == "asm" && !asm) {
        return window.alert("Please Select ARM");
      }
      else if (assignTo == "se" && !rm) {
        return window.alert("Please Select RM");
      }
    }
    if (!form?.name) {
      return window.alert("Please add at least one product")
    }
    if(!form?.quantity){
      return window.alert("Please Enter Quantity")
    }
    console.log(data);
    let pro = specimenProduct.filter((ele) => ele.skuId == data.name);
    data.product = pro[0]
    let pusheItem = { ...data, id: dataGrid.length + 1 }
    console.log(pusheItem)
    setDataGrid([...dataGrid, pusheItem])
    setSelectedClass("")
    setForm({
      name: '',
      unitPrice: '',
      skuCode: '',
      class: '',
      quantity: '',
      selectedClass: '',
      className: '',
    })
  }

  const onsubmit = async (form) => {
    try {
      setLoading(true);
      let payload = {
        userId: userData?.role == "asm" ? rm : assignTo == "se" ? rm : asm,
        role: userData?.role == "asm" ? "se" :  assignTo,
        skuList: dataGrid
      }
      let results = await window.Platform.database.saveAllotSpecimen(payload);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message);
      }
      else {
        onClose1();
      }
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  };


  const seriesHandler = (data) => {
    changeHandler("seriesCategoryId", data)
    changeHandler("seriesName", data.seriesName)
    const seriesData = getSeriesCategory.find((item) => item.seriesTableId === data);
    changeHandler("seriesName", seriesData.seriesName)
    filterProductsfunc(data, form.class)
    // setSeriesCategory(data)
  }

  const getSeriesCategoryData = async () => {
    let results = await window.Platform.database.getSeriesCategory();
    // setgetSeriesCategory(results.data)
    const filteredData = results.data.filter(item => item.specimen == "true");
    setgetSeriesCategory(filteredData);
    if (props?.seriesTableId) {
      const item = results.data.filter((result) => result.seriesTableId === props.seriesTableId)
      // setSeriesCategory(item);
    }
  }

  const getColumns = () => {
    let result = [
      {
        field: "nameSku",
        headerName: "SKU Name",
        width: 170,
        sortable: false,
        renderCell: (params) => {
          console.log(params.row)
          let name = params.row.product.nameSku || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "qty1",
        headerName: "Quantity",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.quantity || 0;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "board",
        headerName: "Board",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.product.boardName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Medium",
        headerName: "Medium",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.product.mediumName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Class",
        headerName: "Class",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.product.className || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Subject",
        headerName: "Subject",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.product.subjectName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Series",
        headerName: "Series",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.product.seriesName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },

      {
        field: "Actions",
        headerName: "Actions",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.total || "N/A"
          return (
            <IconButton onClick={() => handleDeleteEmploye(params.row.id)}>
              <DeleteIcon sx={{ color: "red" }} />
            </IconButton>
          )
        },
      },
    ];
    return result
  }

  const renderContent = () => {
    return (
      <div style={{ minHeight: "100%", overflowY: "auto" }}>
        <div className="row mt-2">
          {userData && userData?.role != "asm" && <>
            <div className="col-md-4">
              <FormControl  disabled={dataGrid.length > 0} fullWidth size="small">
                <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Assign To</InputLabel>
                <Select label="Assign to" value={assignTo} size="small" onChange={(e) => { setAssignTo(e.target.value) }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                  <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} hidden>All</MenuItem>
                  <MenuItem key={1} value={"asm"} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>ARM</MenuItem>
                  <MenuItem key={2} value={"se"} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>RM</MenuItem>
                </Select>
              </FormControl>
            </div>
            {(assignTo == 'asm' || assignTo == "se") && (
              <div className="col-md-4">
                <FormControl  disabled={dataGrid.length > 0} fullWidth size="small">
                  <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select ARM </InputLabel>
                  <Select label="Select ARM" value={asm} size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                    <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                    {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                  </Select>
                </FormControl>
              </div>)}
          </>}
          {(userData && userData?.role == "asm" || assignTo == "se") && <div className="col-md-4">
            <FormControl  disabled={dataGrid.length > 0} fullWidth size="small">
              <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select RM </InputLabel>
              <Select label="Select RM" value={rm} size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
              </Select>
            </FormControl>
          </div>}
        </div>

        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl style={{ width: isMobile ? "100%" : "50%" }}>
            <InputLabel id="select-label">Select Series</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.seriesCategoryId}
              onChange={(e) => seriesHandler(e.target.value)}
              label="Select Option"
            >
              {getSeriesCategory?.map((option, optionIndex) => (
                <MenuItem key={option.seriesTableId} value={option.seriesTableId}>
                  {option.seriesName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl style={{ width: isMobile ? "100%" : "50%" }}>
            <InputLabel id="select-label">Select Class</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.class}
              onChange={(e) => classHandler(e.target.value)}
              label="Select class"
            >
              {className?.map((option, optionIndex) => (
                <MenuItem key={option.classId} value={option.classId}>
                  {option.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </Stack>


        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl required style={{ width: isMobile ? "100%" : "50%" }}>
            <InputLabel required id="select-label">Select Product</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.name}
              onChange={(e) => productHandler(e.target.value)}
              label="Select Option"
            >
              {filterProducts?.map((option, optionIndex) => (
                <MenuItem key={option.skuId} value={option.skuId}>
                  {option.nameSku}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl style={{ width: isMobile ? "100%" : "50%" }}>
            <TextField label="Quantity" value={form.quantity || ""} type="text" fullWidth
              onChange={(e) => changeHandler("quantity", e.target.value)}
              inputProps={{ maxLength: 255 }}
              required
            />
          </FormControl>

        </Stack>
        <Stack direction={"row"} spacing={2} padding={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => handleAdd(form)}>
            Add
          </Button>
        </Stack>
        <DataGrid
          className="payrollGrid"
          style={{ height: !dataGrid.length ? '200px' : 'auto' }}
          density="compact"
          rows={dataGrid || []}
          columns={getColumns()}
          rowHeight={60}
          disableSelectionOnClick
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10]}
        />
        <ButtonContainer>
          <Button
            variant="contained"
            onClick={() => onsubmit(form)}
          >
            Create
          </Button>
        </ButtonContainer>
      </div>
    );
  };

  return (
    <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} PaperProps={{
      style: {
        height: "90vh",
        // maxHeight: "90vh",
        overflowY: "auto",
      },
    }}
    >
      {loading && <OpaqueLoading />}
      <ModalHeaderContainer >
        <Typography variant={isMobile ? "h6" : "h5"}>
          Specimen Allotment
          {/* <Tooltip title="Order Id">{id}</Tooltip> */}
        </Typography>
        <IconButton onClick={onClose1}>
          <CloseOutlined />
        </IconButton>
      </ModalHeaderContainer>
      <TableContainer>
        <TabsContainer>
          <StyledTabs
            variant="fullWidth"
            value={tabValue}
            // onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Specimen Allotment " />
          </StyledTabs>
          {tabValue == 0 && renderContent()}
        </TabsContainer>
      </TableContainer>
    </Dialog>
  );
};

export default SpecimenAllotmentModal;